export default class Calendly {
	private readonly buttonElements: HTMLCollectionOf<Element>;

	// Add this helper method to convert HTMLCollection to Array
	private get buttons(): HTMLAnchorElement[] {
		return Array.from(this.buttonElements) as HTMLAnchorElement[];
	}

	constructor(buttonClass: string) {
		this.buttonElements = document.getElementsByClassName(buttonClass);
	}

	registerButtonListener() {
		const script = document.createElement('script');

		script.onload = () => {
			this.buttons.map((buttonElement: HTMLAnchorElement) => {
				buttonElement.addEventListener('click', (event: MouseEvent) => {
					event.preventDefault();

					// @ts-expect-error TS2339: Property 'Calendly' does not exist on type 'Window & typeof globalThis'.
					window.Calendly.showPopupWidget(buttonElement.href);

					// @ts-expect-error TS2339: Property 'dataLayer' does not exist on type 'Window & typeof globalThis'.
					window.dataLayer.push({
						event: 'logEvent',
						eventType: 'open_calendly',
						eventProperties: {
							section: buttonElement.id,
						},
					});
				});
			});
		};
		script.src = 'https://assets.calendly.com/assets/external/widget.js';

		document.head.appendChild(script);
	}
}
